import React, { useState } from "react";
import { useSelector } from "react-redux";
import { BaseIcon } from "../base-icon/base-icon.component";
import { moneyFormatterUtility } from "../../utilities/number/money-formatter.utility";

import "./main-top-bar.style.scss";
import { Link } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Button, Container } from "reactstrap";
import { ComingSoon } from "../coming-soon/coming-soon.component";

export const MainTopBar = ({ onMenuClick, isOpen }) => {
	const { firstName, lastName, score, city, phoneNumber } = useSelector((state) => state.currentUser);
	const [isSupportSheetOpen, setIsSupportSheetOpen] = useState(false);
	const [isOnlineChatNotSupportedModalOpen, setIsOnlineChatNotSupportedModalOpen] = useState(false);

	const citiesList = useSelector((state) => state.globalData?.initData?.city);
	const userCityId = city?.id;
	const citySupportPhoneNumber = citiesList?.find((city) => city?.id === userCityId)?.supportPhone;

	const handleOnMenuClick = () => {
		onMenuClick();
	};

	// const onOnlineChat = (e) => {
	// 	setIsSupportSheetOpen(false);
	// };

	return (
		<>
			<div className="main-top-bar-holder">
				<div className="main-top-bar">
					<div>
						<h1 className="fw-500 text-primary f-16 mb-50">{`${firstName} ${lastName}`}</h1>
						<div className="f-12">
							<span>اعتبار:</span>
							<span className="mx-25">{moneyFormatterUtility(score)}</span>
							<span>تومانء</span>
						</div>
					</div>
					<div className="d-flex">
						<button className="icon-btn text-body ms-100" onClick={() => setIsSupportSheetOpen(true)}>
							<BaseIcon name="QuestionCircle" />
						</button>
						{/* <Link className="btn icon-btn text-body ms-100" to="/notifications">
							<div className="icon-notif-holder">
								<BaseIcon name="Bell" />
								<span className="icon-notif"></span>
							</div>
						</Link> */}
						<button className="icon-btn position-relative" onClick={handleOnMenuClick}>
							<div className="hamburger-icon-holder">
								<input type="checkbox" className="status-holder" checked={isOpen} />
								<span className="bar top-bar"></span>
								<span className="bar mid-bar"></span>
								<span className="bar bottom-bar"></span>
							</div>
						</button>
					</div>
				</div>
			</div>

			<div className="main-top-bar-holder static">
				<div className="main-top-bar">
					<div>
						<h1 className="fw-500 text-primary f-16 mb-50">{`${firstName} ${lastName}`}</h1>
						<div className="f-12">
							<span>اعتبار:</span>
							<span className="mx-25">{moneyFormatterUtility(score)}</span>
							<span>تومانء</span>
						</div>
					</div>
					<div className="d-flex">
						<button className="icon-btn text-body ms-100" onClick={() => setIsSupportSheetOpen(true)}>
							<BaseIcon name="QuestionCircle" />
						</button>
						{/* <Link className="btn icon-btn text-body ms-100" to="/notifications">
							<div className="icon-notif-holder">
								<BaseIcon name="Bell" />
								<span className="icon-notif"></span>
							</div>
						</Link> */}
						<button className="icon-btn position-relative" onClick={handleOnMenuClick}>
							<div className="hamburger-icon-holder">
								<input type="checkbox" className="status-holder" checked={isOpen} />
								<span className="bar top-bar"></span>
								<span className="bar mid-bar"></span>
								<span className="bar bottom-bar"></span>
							</div>
						</button>
					</div>
				</div>
			</div>

			<BottomSheet open={isSupportSheetOpen} onDismiss={() => setIsSupportSheetOpen(false)}>
				<Container>
					<div className="pt-75 mb-75">
						<h2 className="fw-900 f-16 mb-75">سامانۀ کارو، بفرمائین؟</h2>
						<p className="f-12 fw-400">در خدمتیم؛ چطور می‌تونیم کمکِ‌تون کنیم؟</p>
					</div>
					<ul className="support-list list-unstyled p-0 mb-50">
						<li className="fw-600 f-12">
							<a href={`tel:${citySupportPhoneNumber}`} className="link-dark dis-vet-center">
								<span className="ms-50 dis-vet-center">
									<BaseIcon name="PhoneCall" size={16} color="#000000" />
								</span>
								<span>تماس با پشتیبانی</span>
							</a>
						</li>
						<li className="fw-600 f-12">
							<a href="/faq" className="link-dark dis-vet-center">
								<span className="ms-50 dis-vet-center">
									<BaseIcon name="ListLeft" size={16} color="#000000" />
								</span>
								<span>سوالات متداول</span>
							</a>
						</li>
						{/* <li className="fw-600 f-12">
							<a
								className="link-dark dis-vet-center cursor-pointer"
								href={`https://support.ecoapp.ir?userFullName=${firstName} ${lastName}&phoneNumber=${phoneNumber}`}
								rel="noopener noreferrer"
								target="_blank"
								onClick={onOnlineChat}
							>
								<span className="ms-50 dis-vet-center">
									<BaseIcon name="MessageSquareLines" size={16} color="#000000" />
								</span>
								<span>
									<span>گفتگوی آنلاین</span> */}
						{/* <span className="text-muted f-10 me-25">(بزودی)</span> */}
						{/* </span>
							</a>
						</li> */}
					</ul>
					<div>
						<Button block color="semi-success mb-75" onClick={() => setIsSupportSheetOpen(false)}>
							مرسی، الان مسئله‌ای ندارم
						</Button>
					</div>
				</Container>
			</BottomSheet>

			<ComingSoon
				isOpen={isOnlineChatNotSupportedModalOpen}
				onClose={() => setIsOnlineChatNotSupportedModalOpen(false)}
			/>
		</>
	);
};
